import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import AssortmentMenu from '../AssortmentMenu'
import CompanyMenu from '../CompanyMenu'
import ServiceMenu from '../ServiceMenu'

import { IconNumber } from './styles'
import { Dashboard, Bean, Wrench, Agenda, MenuChevronRight, Cart, Cogwheel } from '../../Icons'
import {
  BottomBarDropDown,
  BottomBarDropDownItem,
  BottomBarDropDownIconContainer,
  BottomBarName,
  BottomBarNext
} from '../../../styles/defaults-header'

class PageMenuDropdown extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  handleClickAssort() {
    this.props.onClickBackAssort()
  }

  handleClickCompany() {
    this.props.onClickBackCompany()
  }

  handleClickService() {
    this.props.onClickBackService()
  }

  render() {
    const { permissions } = this.props
    return (
      <BottomBarDropDown right main>
        {this.props.assortActive || this.props.companyActive || this.props.serviceActive ? (
          <Fragment>
            {this.props.assortActive ? (
              <AssortmentMenu onClickLink={this.props.onClickLink} onClickBack={this.props.onClickBackAssort} />
            ) : null}
            {this.props.companyActive ? (
              <CompanyMenu
                permissions={permissions}
                onClickLink={this.props.onClickLink}
                onClickBack={this.props.onClickBackCompany}
              />
            ) : null}
            {this.props.serviceActive ? (
              <ServiceMenu
                permissions={permissions}
                onClickLink={this.props.onClickLink}
                onClickBack={this.props.onClickBackService}
              />
            ) : null}
          </Fragment>
        ) : (
          <Fragment>
            <BottomBarName>Menu</BottomBarName>
            <Link to="/" onClick={this.handleClick.bind(this)}>
              <BottomBarDropDownItem>
                <BottomBarDropDownIconContainer>
                  <Dashboard size="" />
                </BottomBarDropDownIconContainer>
                Dashboard
              </BottomBarDropDownItem>
            </Link>

            {permissions.viewAssortiment ? (
              <BottomBarDropDownItem onClick={this.handleClickAssort.bind(this)} className="js-sub">
                <BottomBarDropDownIconContainer>
                  <Bean size="" />
                </BottomBarDropDownIconContainer>
                Assortiment
                <BottomBarNext>
                  <MenuChevronRight size="" />
                </BottomBarNext>
              </BottomBarDropDownItem>
            ) : null}

            {permissions.viewOrders ? (
              <Fragment>
               <Link to="/bestellijst" onClick={this.handleClick.bind(this)}>
                <BottomBarDropDownItem>
                  <BottomBarDropDownIconContainer>
                    <Cart size="" />
                  </BottomBarDropDownIconContainer>
                  Mijn bestellijst
                  {this.props.nrOfOrders ? <IconNumber>{this.props.nrOfOrders}</IconNumber> : null}
                </BottomBarDropDownItem>
              </Link>
              </Fragment>
            ) : null}


              <BottomBarDropDownItem onClick={this.handleClickService.bind(this)}>
                <BottomBarDropDownIconContainer>
                  <Wrench size="" />
                </BottomBarDropDownIconContainer>
                Klantenservice
                <BottomBarNext>
                  <MenuChevronRight size="" />
                </BottomBarNext>
              </BottomBarDropDownItem>


            {permissions.viewBranch ? (     
              <BottomBarDropDownItem onClick={this.handleClickCompany.bind(this)}>
                <BottomBarDropDownIconContainer>
                  <Cogwheel size="" />
                </BottomBarDropDownIconContainer>
                Mijn bedrijf
                <BottomBarNext>
                  <MenuChevronRight size="" />
                </BottomBarNext>
              </BottomBarDropDownItem>
             ) : null}


            {permissions.viewAgenda ? (
              <Link to="/agenda" onClick={this.handleClick.bind(this)}>
                <BottomBarDropDownItem>
                  <BottomBarDropDownIconContainer>
                    <Agenda size="" />
                  </BottomBarDropDownIconContainer>
                  Agenda
                </BottomBarDropDownItem>
              </Link>
            ) : null}
          </Fragment>
        )}
      </BottomBarDropDown>
    )
  }
}

export default withRouter(PageMenuDropdown)



// WEBPACK FOOTER //
// ./src/components/MobileHeader/PageMenuDropdown/index.js